module.exports = __webpack_public_path__ + "img/imgFail.6f06dbbd.png";